import { brands as compiledBrands } from 'virtual:today-brands'
import type { BrandRuntimeArtifact, ValidBrandRuntimeArtifact } from '@today/brand-config/runtime'
import { useMemo } from 'react'
import { selectViewerBrand } from './select-viewer-brand'
import { usePlatformBrandId } from './use-platform-brand'

const findValid = (
	brands: readonly BrandRuntimeArtifact[],
	id: string | null,
): ValidBrandRuntimeArtifact | undefined =>
	id === null
		? undefined
		: brands.find((candidate): candidate is ValidBrandRuntimeArtifact => candidate.valid && candidate.id === id)

/**
 * The brand a tenant's login surface binds (TO-541 REQ-104): the tenant brand id
 * from `login-options` when it is compiled, else the runtime platform brand —
 * also while `login-options` is pending (`null`). Display only, never authorization.
 */
export function useLoginBrand(
	tenantBrandId: string | null,
	brands: readonly BrandRuntimeArtifact[] = compiledBrands,
): ValidBrandRuntimeArtifact {
	const platformBrandId = usePlatformBrandId(brands)
	return useMemo(
		() => findValid(brands, tenantBrandId) ?? selectViewerBrand(null, brands, platformBrandId),
		[brands, tenantBrandId, platformBrandId],
	)
}
